import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import FormCreate from '@/components/FormCreate';
import md5Encrypt from '@/utils/addSecret';
import { PWD_REGEXP } from '../../constants';

const { FormPwd } = FormCreate;

@Form.create()
class PwdModal extends Component {
  handleOk = () => {
    const { onOk, form } = this.props;
    const password = form.getFieldValue('password');
    form.validateFields(err => {
      if (!err && onOk) {
        onOk(md5Encrypt(password));
      }
    })
  };

  render() {
    const { form, visible, loading, onCancel } = this.props;
    const normPwdProps = {
      keyName: 'password',
      isRequired: true,
      form,
      label: '密码',
      message: '请输入密码（8位数字字母组合）',
      placeholder: '请输入密码',
      maxLength: 8,
      pattern: PWD_REGEXP,
    };

    return (
      <Modal
        centered
        title="输入密码"
        visible={visible}
        width={600}
        onOk={this.handleOk}
        onCancel={onCancel}
        okButtonProps={{
          disabled: !form.getFieldValue('password'),
        }}
        confirmLoading={loading}
        maskClosable={false}
      >
        <FormCreate>
          <FormPwd {...normPwdProps} />
        </FormCreate>
      </Modal>
    );
  }
}

export default PwdModal;
